import { COMPANY } from "@/lib/company-info";
import HoferLogo from "@assets/hofer/hofer-logo.png";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white border-t border-gray-200 py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img
              src={HoferLogo}
              alt={COMPANY.brand}
              className="h-8 w-auto flex-shrink-0"
            />
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-bold text-bauwerk-slate">
                {COMPANY.name}
              </span>
              <span className="text-[11px] text-bauwerk-slate/80">{COMPANY.tagline}</span>
            </div>
          </div>
          <p className="text-bauwerk-slate/70 text-xs text-center sm:text-right">
            © {year} {COMPANY.legalName}. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
}
